import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import { Fragment, useState, useEffect } from "react";
import Tooltip from "./Tooltip";
import { useTranslation } from "react-i18next";
const SearchPageHeader = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "searchPageHeader" });
  const location = useLocation();
  const dispatch = useDispatch();
  const categoryName = useSelector((index) => index.categoryName);
  const subcategoryName = useSelector((index) => index.subcategoryName);
  const rearchresults = useSelector((index) => index.rearchresults);
  const favoritearray = useSelector((index) => index.favoritearray);
  const searchBy = useSelector((state) => state.searchBy);
  const keywordEntered = useSelector((state) => state.keyword);
  const state1 = useSelector((state) => state);
  const isPogress = useSelector((index) => index.isPogress);
  const showFavorite = () => {
    dispatch(ramactions.changestatus(2));
  };
  const isFavAdded = useSelector((state) => state.isFavoriteAdded);
  const isFavRemoved = useSelector((state) => state.isFavoriteRemoved);
  useEffect(() => {
    //console.log(state1);
    let timer1;
    timer1 = setTimeout(() => {
      dispatch(ramactions.faviruteAdded(false));
      dispatch(ramactions.faviruteRemoved(false));
      //console.log("removed");
    }, 4000);

    return () => {
      clearTimeout(timer1);
    }
  }, [isFavRemoved, isFavAdded]);

  useEffect(()=>{
    // Window scrolled to top when component destroyed.
    return () => {
      window.scrollTo(0,0)
    }
  },[])
  return (
    <div className="app-header-wrapper">
      <div className="fixed-fluid-container">
        <div className="app-header d-flex justify-content-between align-items-center">
          {!isPogress && (
            <h2
              className={`header_topic ${searchBy === "keyword" && "keyword"}`}
              tabindex="0"
            >
              {searchBy === "topic" && (
                <Fragment>
                  <span className="header-one">{categoryName}</span>
                  <span className="results-count">
                    {subcategoryName}{" "}
                    {!isPogress && (
                      <Fragment>({rearchresults.length} {t("results")})</Fragment>
                    )}
                  </span>
                </Fragment>
              )}
              {searchBy === "keyword" && (
                <Fragment>
                  <p>{t("showing_keyword_results")}</p>
                  <span className="header-four">"{keywordEntered}"</span>
                </Fragment>
              )}
              <span className="sr-only">
              {t("search_result_with")} {rearchresults.length} {t("of")}{" "}
                {rearchresults.length} {t("items")}
              </span>
            </h2>
          )}
          {/* {!isPogress && <div className="resources_count">{rearchresults.length}</div>} */}
          {!isPogress && (
            <div className="right-controls">
              <Link
                aria-label={
                  t("go_to_fav") +
                  favoritearray.length +
                  " " + t("item")
                }
                className="fav-wrapper"
                to={{
                  pathname: location.pathname,
                  hash: "#favorites",
                }}
                onClick={showFavorite}
              >
                {(isFavAdded || isFavRemoved) && <Tooltip tipText={isFavAdded ? t("add_to_favorite_tooltip"): isFavRemoved && t("removed_from_favorites_tooltip") }></Tooltip>}
                <span className="bts bt-star" aria-hidden="true"></span>
                <span className="sr-only">{t("favourites")}</span>
                <span className="step step-physical">
                  {favoritearray.length}
                </span>
              </Link>

              <Link onClick={props.goBackHome} className="search-home">
              {t("edit_search")}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default SearchPageHeader;
